import { rootApi } from 'root-api'

const api = rootApi.enhanceEndpoints({ addTagTypes: ['REPORT'] }).injectEndpoints({
  endpoints: (build) => ({
    fetchUsersCalendarIntegrationsReport: build.query({
      query: ({
        organization,
        currentUserId,
        ...params // additional optional params such as groupBy, sort
      }) => ({
        url: '/api/reports/users/integrations/calendar',
        params: {
          organization,
          currentUserId,
          ...params
        }
      }),
      providesTags: ['REPORT']
    }),
    fetchUsersWebConferencingIntegrationsReport: build.query({
      query: ({
        organization,
        currentUserId,
        ...params // additional optional params such as groupBy, sort
      }) => ({
        url: '/api/reports/users/integrations/web_conferencing',
        params: {
          organization,
          currentUserId,
          ...params
        }
      }),
      providesTags: ['REPORT']
    }),
  })
})

export const {
  useFetchUsersCalendarIntegrationsReportQuery,
  useFetchUsersWebConferencingIntegrationsReportQuery
} = api
